/**
 * @fileoverview Input/output schemas for chapter-entity-detector-v2.
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';

// =============================================================================
// FLOW INPUT SCHEMA
// =============================================================================

/**
 * Full input for the agent flow.
 */
export const InputSchema = z.object({
  ...BaseFlowInputSchema.shape,
  ...AGENT_SCHEMA_OBJECTS.chapterContent.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.knownCharacters.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.knownWorldElements.schema.shape,
});

export type Input = z.infer<typeof InputSchema>;

// =============================================================================
// OUTPUT SCHEMA
// =============================================================================

export const OutputSchema = z.object({
  characters: z.array(z.object({
    name: z.string().describe("The full name of the identified character."),
  })).describe("An array of all named characters who play a meaningful role in the provided chapter text."),
  worldElements: z.array(z.object({
    name: z.string().describe("The exact name of the identified world element, as it appears in the known world elements list."),
    type: z.string().describe("The type of the world element (e.g. place, object, event, organization, species, system, set)."),
  })).describe("An array of all known world elements that have a meaningful presence in the provided chapter text."),
});

export type Output = z.infer<typeof OutputSchema>;
